// extracted by mini-css-extract-plugin
module.exports = {"star":"star_1YC2A","destinationWarning":"destinationWarning_F1bSt","radioStyle":"radioStyle_2NQ_q","destinationMsgFont":"destinationMsgFont_deq6z"};